export default __webpack_public_path__ + "static/media/card-sip-icon.c35622f2.svg";